// Created By JasonNing on 2018/7/13

export const apiConfig = {
    user: {
        'login': 'User/Login|POST',
        'loopLogin': 'User/GetTokenFromLoginQr|GET',
        'getUserInfo': 'User/GetAccountByToken|GET',
        'sendCode': 'User/SendMsg|GET',
        'checkCode': 'User/ValidSMS|GET',
        'updatePassword': 'User/UpdateUserPassword|POST',
        'checkEditor': 'User/CheckEditor|GET', //判断编辑身份

        'GetUserFeedbacks': 'User/GetUserFeedbacks|GET',
        'GetUnsubscribes': 'User/GetUnsubscribes|GET',

        'GetTempPassWord': 'User/GetTempPassWord|GET',
    },
    Locale: {
        'List': 'Locale/List|GET', //获取省份&传参&id=1获取地区市区
        'GetSchoolByLocaleId': 'School/GetSchoolByLocaleId|GET', //根据地区Id获取学校
    },
    School: {
        'SearchAllSchool': 'School/SearchAllSchool|GET',
    },
    Subject: {
        'subjectList': 'Subject/List|GET',//获取二级学科
        'SubjectByGrade': 'Subject/SubjectByGrade|GET',//根据年纪获取学科
    },
    Grade: {
        'gradeList': 'Grade/List|GET',//获取二级学科
    },
    coursewarePublish: {
        'ShowAllQueue': 'CoursewarePublish/ShowAllQueue|GET',//列表接口
        'GetTaskInfo': 'CoursewarePublish/GetTaskInfo|GET',
        'MoveTaskToInprogess': 'CoursewarePublish/MoveTaskToInprogess|POST',
        'ShowTaskCount': 'CoursewarePublish/ShowTaskCount|GET',
        'DeleteTask': 'CoursewarePublish/DeleteTask|POST',
    },
    FeedbackSearch: {
        'coursewareList': 'FeedbackSearch/CoursewareList|GET'//获取纠错进度
    },
    HexCubeBatch: {
        'GetSchoollistFromHexCube': 'HexCubeBatch/GetSchoollistFromHexCube|GET',
        'GetHtelistFromHexCube': 'HexCubeBatch/GetHtelistFromHexCube|GET',
        'GetStudentHTESubmittedList': 'HexCubeBatch/GetStudentHTESubmittedList|GET',
        'SearchHexCubeBatchByHteAndStudent': 'HexCubeBatch/SearchHexCubeBatchByHteAndStudent|GET',
        'CreateHteInspect': 'HexCubeBatch/CreateHteInspect|POST',
        'CheckStudentResource': 'HexCubeBatch/CheckStudentResourceAsync|POST',//个人审核接口
        'GetAbnormalPic': 'HexCubeBatch/SearchORCExceptionResourceListAsync|GET',//异常图片列表

        'SearchHteListFromHexCubeAsync': 'HexCubeBatch/SearchHteListFromHexCubeAsync|GET',
        'SearchSubmitHteStudentList': 'HexCubeBatch/SearchSubmitHteStudentList|GET',
        'SearchPageContentListByHte': 'HexCubeBatch/SearchPageContentListByHte|GET',
        'SearchStudentListByKeyword': 'HexCubeBatch/SearchStudentListByKeyword|GET',
        'SearchStudentPictureListByHte': 'HexCubeBatch/SearchStudentPictureListByHte|GET',
        'SaveCorrectResult': 'HexCubeBatch/SaveCorrectResult|POST',
        'SearchSubmitStudyClassByHteId': 'HexCubeBatch/SearchSubmitStudyClassByHteId|GET',//type=1或2时，点击进度条的分班接口
    },
    ExercisesPool: {
        'GetExercisePoolInfo': 'ExercisesPool/GetExercisePoolInfo|GET',
        'GetExercisePoolInfoAsync': 'ExercisePoolK12/GetExercisePoolInfoAsync|GET',
        'GetExercisePoolByIdAsync': 'ExercisePoolK12/GetExercisePoolByIdAsync|GET',
        'SearchAllUnionSchoolAndLocale': 'School/SearchAllUnionSchoolAndLocale|GET',
        'SearchSchoolListBySchoolName': 'School/SearchSchoolListBySchoolName|GET',
        'AddExercisePoolAndSchool': 'ExercisesPool/AddExercisePoolAndSchool|POST',
        'IsExercisePoolTypeAsync': 'ExerciseK12/IsExercisePoolTypeAsync|GET', //判断题库类型  （true：OCR录入、false：手动录入）
        //OCR题库目录相关
        'SearchPoolChapterAsync': 'ExercisePoolK12/SearchPoolChapterAsync|GET',
        'SavePoolChapterAsync': 'ExercisePoolK12/SavePoolChapterAsync|POST',
        'UpdateEChapterAsync': 'EChapter/UpdateEChapterAsync|POST',
        'DeleteEChapterAsync': 'EChapter/DeleteEChapterAsync|POST',
        'ChangeEChapterSequenceAsync':'ExerciseContents/ChangeEChapterSequenceAsync|POST',
        'UpdateEchapterParentAsync': 'ExercisePoolK12/UpdateEchapterParentAsync|POST', //章节目录调序(2级变1级,3级变2级、1级)
        //题库习题相关
        'GetExerciseBookSubjectCourse': 'ExerciseBook/GetExerciseBookSubjectCourse|GET',
        'SearchExerciseTypeAliasBySubjectCourseIdAsync': 'ExercisesPool/SearchExerciseTypeAliasBySubjectCourseIdAsync|GET',
        'GetExerciseListByExercisePoolId': 'ExercisesPool/GetExerciseListByExercisePoolId|GET',
        'GetExerciseListByExercisePoolNew': 'ExercisesPool/GetExerciseListByExercisePoolNew|GET', //获取习题
        'RemoveExerciseAsync': 'ExerciseK12/RemoveExerciseAsync|POST',
        'AddExerciseListToPoolAndEChapter': 'ExerciseK12/AddExerciseListToPoolAndEChapterAsync|POST',
        'GetMyExercisePoolListBySubjectCourse': 'ExercisesPool/GetMyExercisePoolListBySubjectCourse|GET',
        'CopyBatchExercise': 'ExercisesPool/CopyBatchExercise|POST',
        'BatchUsedExerciseAsync': 'ExerciseK12/BatchUsedExerciseAsync|POST', //批量采用习题
        'CheckMyExercisePool': 'ExercisePoolK12/CheckMyExercisePool|GET', //判断是否是我创建的
        'CopyExerciseByExerciseId': 'ExercisesPool/CopyExerciseByExerciseId|POST', //根据习题复制创建新题
        'GetSubjectBySubjectCourseID':'Subject/GetSubjectBySubjectCourseID|GET',//根据课程加载相应字体
        'GetExerciseBookSubjectCourse':'ExerciseBook/GetExerciseBookSubjectCourse|GET',
        
        'GetExercisePoolPageNumsAsync': 'ExercisePoolPageNum/GetExercisePoolPageNumsAsync|GET', //获取题库页码
        'CreateExercisePoolPageNumAsync': 'ExercisePoolPageNum/CreateExercisePoolPageNumAsync|POST', //批量录页码
        'UpdateExercisePageNumAsync': 'ExercisePoolAndExerciseAsync/UpdateExercisePageNumAsync|POST', //批量修改习题页码
        'SearchExercisePageAndNumberAsync': 'ExercisePoolAndExerciseAsync/SearchExercisePageAndNumberAsync|GET', //获取习题页码和题号
        'SaveExerciseNumberAsync': 'ExercisePoolK12/SaveExerciseNumberAsync|POST', //修改习题题号
        'SearchExercises':'ExerciseK12/SearchExercises|GET',//京版习题视图列表
        'SearchMarkTreeEChapter':'ExerciseBookContents/SearchMarkTreeEChapter|GET',
        'ChangeEChapterSequenceAsync':'ExerciseContents/ChangeEChapterSequenceAsync|POST', //目录新调序
        'SeachAttacheFiledByExercisePoolID':'AttachedFile/SeachAttacheFiledByExercisePoolID|GET', //查询题库下所有的音频资源
        'SeachAttacheFiledListByExercisePoolID':'AttachedFile/SeachAttacheFiledListByExercisePoolID|GET',//查询题库下所有的音频资源无分页
        'InsertEChapterAndResource':'AttachedFile/InsertEChapterAndResource|POST',//绑定音频与章节关系
        'SeachResourceByEChapterID':'AttachedFile/SeachResourceByEChapterID|GET',//查询章节底下的附件信息
        'DeleteEChapterAndResource':'AttachedFile/DeleteEChapterAndResource|POST',//解除音频与章节的关系
        'EchapterHaveExercise':'ExerciseK12/EchapterHaveExercise|GET' // 章节下是否有小题
    },
    ExerciseBook: {
        'GetExerciseBookListForEditorPlatform': 'ExerciseBook/GetExerciseBookListForEditorPlatform|GET',
        'GetEditPortExerciseBookListByPage': 'ExerciseBook/GetEditPortExerciseBookListByPage|GET',
        'ModifExerciseBookStatu': 'ExerciseBook/ModifExerciseBookStatu|POST',
        'GetExerciseBookContentsById': 'ExerciseBookContents/GetExerciseBookContentsById|GET',
        'SaveExerciseBookComposing': 'ExerciseBookContents/SaveExerciseBookComposing|POST',
        'saveEditorHtePaperStatus': 'ExerciseBookContents/EditorHtePaperStatu|POST',
        //授权学校
        'GetExerciseBookById': 'ExerciseBook/GetExerciseBookById|GET',
        'GetResUNSchoolModel': 'ExerciseBook/GetResUNSchoolModel|GET',
        'CreateExerciseBookAndSchool': 'ExerciseBook/CreateExerciseBookAndSchool|POST',
        'SeachSchoolByExerciseBookID': 'ExerciseBook/SeachSchoolByExerciseBookID|GET',
        'RemoveExerciseBookAndSchool': 'ExerciseBook/RemoveExerciseBookAndSchool|POST',
        //封面
        'GetExerciseBookPrintCover': 'ExerciseBook/GetExerciseBookPrintCover|GET',
    },
    //采集异常
    CollectionAnomaly: {
        'WrongPic': 'HexCubeCollectWork/CollectOCRExceptionPictureAsync|POST',//采集识别异常图片
        'CorrectPicInfo': 'HexCubeBatch/CorrectOCRExceptionResourceAsync|POST',//纠正异常图片(提交)
        'SaveCorrectResult': 'HexCubeBatch/SaveCorrectResult|POST',//纠正考号异常提交
        'ExerciseList': 'HexCube/GetExerciseListByPageIdAsync|GET',//获取当前页面的所有习题id
        'QuestionList': 'ExerciseTeacherSearch/ExerciseList|GET',//获取所有题型
        'AnswersList': 'DoHomeTestExam/GetStudentAnswerByExerciseIds|GET',//获取所有答案
        'CorrectSubject': 'WorkBook/JudgmentExercise|POST',//简答题
        'CorrectObjective': 'JudgmentExercise/JudgmentObjectiveExercise|POST',//主观题判题接口
        'showPicByClass': 'HexCubeBatch/SearchSubmitWorkBookStudentList|GET',//根据班级获取图片
        'collectData': 'Report/RecordCorrectOCRResultLog|POST',//数据收集的接口
        'statisticsList': 'Report/SearchOcrStatisticsByDate|GET',//识别结果统计列表
        'resultStatisticsList': 'Report/SearchCorrectResultLogByDate|GET',//纠正记录列表
    },
    Exercise: {
        'ExerciseList': 'ExerciseTeacherSearch/ExerciseList|GET',
        'GetKeyPointListByExerciseId': 'ExerciseCreate/GetKeyPointListByExerciseId|GET',
        'SearchKeyPointByExerciseIdsAsync': 'ExerciseK12/SearchKeyPointByExerciseIdsAsync|POST', //批量获取习题知识点
    },
    OCR: {
        'SearchResourceByExercisePoolAsync': 'EChapterAndResource/SearchResourceByExercisePoolAsync|GET',
        'SaveEChapterResourceAsync': 'EChapterAndResource/SaveEChapterResourceAsync|POST',
        'SaveResourceStatusAsync': 'EChapterAndResource/SaveResourceStatusAsync|POST',
        'RemoveResourceByExercisePoolAsync': 'EChapterAndResource/RemoveResourceByExercisePoolAsync|POST',
        'RemoveEChapterResourceAsync': 'EChapterAndResource/RemoveEChapterResourceAsync|POST',
        'SearchEChapterStatusAsync': 'EChapterAndResource/SearchEChapterStatusAsync|GET',
        'SearchResourceByExerciseAsync': 'ExerciseK12/SearchResourceByExerciseAsync|GET',
        'GetResourceByExerciseAsync': 'ExerciseK12/GetResourceByExerciseAsync|GET',
        'SearchExercisePoolOCRList':'EChapterAndResource/SearchExercisePoolOCRList|GET'
    },
    ExercisePools: {
        //获取试卷库信息
        'GetExercisePoolByHTEIdAsync': 'ExercisePoolAsync/GetExercisePoolByHTEIdAsync|GET',
        //获取下拉框内容
        'GetPaperCharacteristics': 'ExercisesPool/GetPaperCharacteristics|GET',
        'SearchGradesAsync': 'GradeAsync/SearchGradesAsync|GET',
        'GetLocaleAsync': 'LocaleAsync/GetLocaleAsync|GET',
        //创建试卷
        'CreateHtePoolHteAsync': "HTEPaper/CreateHtePoolHteAsync|POST",
        'GetHtepaperByIdAsync': 'HTEPaper/GetHtepaperByIdAsync|GET', //获取试卷
        'UpdateHtePoolHteAsync': "HTEPaper/UpdateHtePoolHteAsync|POST",
        'DeleteHTEPaperAsync': "HTEPaper/DeleteHTEPaperAsync|POST", //删除试卷
        'IsExistHtePoolHteNameAsync': 'HTEPaper/IsExistHtePoolHteNameAsync|GET', //判断试卷名称是否重复
        'UpdateHTEPaperPublishStatusAsync': "HTEPaper/UpdateHTEPaperPublishStatusAsync|POST",//修改试卷发布状态
        //查询试卷库下的所有试卷
        'GetHtePoolHteAsync': 'HTEPaper/GetHtePoolHteAsync|GET',
        //获取试卷下的习题
        'GetHTEPaperToExerciseIDAsync': 'HTEPaper/GetHTEPaperToExerciseIDAsync|GET',
        'EnteringHtePaperToExerciseAsync': 'HTEPaper/EnteringHtePaperToExerciseAsync|POST', //添加试卷下习题
        'CoverHtePaperToExerciseAsync': 'HTEPaper/CoverHtePaperToExerciseAsync|POST', //修改试卷下习题
        'RemoveHtePaperToExerciseAsync': 'HTEPaper/RemoveHtePaperToExerciseAsync|POST', //删除试卷下的题
        'SaveHtePaperAndExerciseAsync': 'HTEPaper/SaveHtePaperAndExerciseAsync|POST', //试卷下习题调序
        'GetExerciseUseCount':'Exercises/GetExerciseUseCount|GET', //判断被用过几次
        'CreateEChapter':'ExerciseBookContents/CreateEChapter|POST' //新建章节
    }
}
